import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsKdeComponent } from './simple-icons-kde.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsKdeComponent ],
    exports:      [ SimpleIconsKdeComponent ],
    bootstrap:    []
})
export class SimpleIconsKdeModule {}
